
    import '/home/ec2-user/Youlify-Design/components/s3-upload/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["s3-upload-demo-basic"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/s3-upload/index.en-US.md?type=demo')
};